import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { WorkshopsScheduleState } from './types';
import { RootState } from '@/vuex/types';
import { defaultWeekSchedule } from './dafaults';

export const state: WorkshopsScheduleState = {
    weekSchedule: {
        WeekScheduleSettings: {},
        WeekDays: [
            {
                Id: 0,
                Name: '',
                Timeline: { Title: '', TimelineStartTime: '', TimelineEndTime: '', TimeUnits: [] },
                Locations: [{ Name: '', Rooms: [{ Name: '', Workshops: [] }] }],
            },
        ],
    },
    filteredWeekDays: [],
    timeline: { Title: '', TimelineStartTime: '', TimelineEndTime: '', TimeUnits: [] },
    selectedWorkshopsIds: [],
    selsctedTicketsIds: [],
    availableTicketTypes: [],
    eventRegistrationId: null,
    eventRegistrationGuid: null,
    recommendedBy: null,
    loading: false,
    isGuidelineVisible: false,
    isFilteringVisible: true,
    eventTickets: [],
};

const namespaced = true;

export const workshopsSchedule: Module<WorkshopsScheduleState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
